export function getTheme() {
  //   const grayColor = "rgb(100 116 139)";
  //   const grayColor = "rgb(148 163 184)"; slate-500
  //   const grayColor = "rgb(161, 161, 170)"; // default-500
  const grayColor = "rgb(148 163 184)";

  const theme = {
    background: "transparent",
    crosshair: {
      line: {
        stroke: "#ffffff",
        strokeWidth: 2,
        // strokeOpacity: 0.35,
      },
    },
    text: {
      fontSize: 12,
      fill: "#ffffff",
      outlineWidth: 0,
      outlineColor: "#000000",
    },
    axis: {
      textColor: "#fff",
      fontSize: 12,
      tickColor: "#fff",
      domain: {
        line: {
          stroke: grayColor,
          strokeWidth: 1,
        },
      },
      legend: {
        text: {
          fontSize: 12,
          //   fill: "#fff",
          fill: grayColor,
          outlineWidth: 0,
          outlineColor: "transparent",
        },
      },
      ticks: {
        line: {
          stroke: "#ffffff",
          strokeWidth: 0,
        },
        text: {
          fontSize: 12,
          //   fill: "#ffffff",
          fill: grayColor,
          outlineWidth: 0,
          outlineColor: "#ffffff",
        },
      },
    },
    grid: {
      line: {
        stroke: "#dddddd",
        strokeWidth: 0,
      },
    },
    legends: {
      title: {
        text: {
          fontSize: 12,
          fill: "#ffffff",
          outlineWidth: 0,
          outlineColor: "#ffffff",
        },
      },
      text: {
        fontSize: 12,
        fill: "#ffffff",
        outlineWidth: 0,
        outlineColor: "#ffffff",
      },
      ticks: {
        line: {},
        text: {
          fontSize: 10,
          fill: "#ffffff",
          outlineWidth: 0,
          outlineColor: "transparent",
        },
      },
    },
    annotations: {
      text: {
        fontSize: 1,
        fill: "#333333",
        outlineWidth: 2,
        outlineColor: "#ffffff",
        outlineOpacity: 1,
      },
      link: {
        stroke: "#000000",
        strokeWidth: 1,
        outlineWidth: 2,
        outlineColor: "#ffffff",
        outlineOpacity: 1,
      },
      outline: {
        stroke: "#ffffff",
        strokeWidth: 2,
        outlineWidth: 2,
        outlineColor: "#ffffff",
        outlineOpacity: 1,
      },
      symbol: {
        fill: "#000000",
        outlineWidth: 2,
        outlineColor: "#ffffff",
        outlineOpacity: 1,
      },
    },
    tooltip: {
      container: {
        // background: "#000000",
        background: "rgb(30 41 59)",
        // rgb(15 23 42 / var(--tw-text-opacity))
        color: "#ffffff",
        fontSize: 12,
      },
      basic: {},
      chip: {},
      table: {},
      tableCell: {},
      tableCellValue: {},
    },
  };

  return theme;
}
